var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgChartLine(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 15,
    viewBox: "0 0 21 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.7646 12.5H2.88965V0.625C2.88965 0.3125 2.57715 0 2.26465 0H1.01465C0.663086 0 0.389648 0.3125 0.389648 0.625V13.75C0.389648 14.4531 0.936523 15 1.63965 15H19.7646C20.0771 15 20.3896 14.7266 20.3896 14.375V13.125C20.3896 12.8125 20.0771 12.5 19.7646 12.5ZM18.5146 1.25H13.8662C13.0459 1.25 12.6162 2.26562 13.2021 2.85156L14.4912 4.14062L11.6396 6.99219L8.74902 4.14062C8.28027 3.63281 7.45996 3.63281 6.99121 4.14062L4.2959 6.83594C4.06152 7.07031 4.06152 7.46094 4.2959 7.69531L5.19434 8.59375C5.42871 8.82812 5.81934 8.82812 6.05371 8.59375L7.88965 6.79688L10.7412 9.64844C11.21 10.1562 12.0303 10.1562 12.499 9.64844L16.249 5.89844L17.5381 7.1875C18.124 7.77344 19.1006 7.34375 19.1006 6.52344V1.875C19.1396 1.5625 18.8271 1.25 18.5146 1.25Z",
    fill: "#4F4184"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChartLine);
export default __webpack_public_path__ + "static/media/chart-line.5c91c82d.svg";
export { ForwardRef as ReactComponent };